import { useMemo, useState } from 'react';
import { currentPageContext } from './currentPageContext';

export interface Props {
  children?: React.ReactNode;
}

export const CurrentPageProvider = ({ children }: Props) => {
  const [pageTitle, setPageTitle] = useState('');
  const [leftContent, setLeftContent] = useState<React.ReactNode>(null);
  const [rightContent, setRightContent] = useState<React.ReactNode>(null);
  const [safeAreaTopColor, setSafeAreaTopColor] = useState<string | null>(null);
  const [isSafeAreaTopFullBleed, setIsSafeAreaTopFullBleed] = useState(false);

  const value = useMemo(
    () => ({
      pageTitle,
      setPageTitle,
      leftContent,
      setLeftContent,
      rightContent,
      setRightContent,
      safeAreaTopColor,
      setSafeAreaTopColor,
      isSafeAreaTopFullBleed,
      setIsSafeAreaTopFullBleed,
    }),
    [pageTitle, leftContent, rightContent, safeAreaTopColor, isSafeAreaTopFullBleed],
  );

  return <currentPageContext.Provider value={value}>{children}</currentPageContext.Provider>;
};
